import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BRANCH } from "constants/AuthConstant";
import AppManagerService from "services/AppManagerService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  result: {},
  userBranchList: {},
  refreshList: false,
  getCount: "",
};

export const getUserBranchList = createAsyncThunk(
  "appManager/getUserBranchList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AppManagerService.getUserBranchList();
      if (response.status === 201 || response.status === 200) {
        if (response.data.status == "Success") {
          console.log("🚀 ~ responseAppManager:", response);
          return response;
        } else {
          notification.error({
            message: "Error",
            description: "Unexpected response!",
            duration: 3,
          });
        }
        return response || "No Response";
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(error.response?.data.message || "Catched error!");
    }
  }
);

export const AppManagerSlice = createSlice({
  name: "appManager",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      localStorage.setItem(BRANCH, JSON.stringify(action.payload));
      state.selectedBranch = action.payload;
    },
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      //get list branch
      .addCase(getUserBranchList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getUserBranchList.fulfilled, (state, action) => {
        state.loading = false;
        state.userBranchList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getUserBranchList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, branchsSuccess, showLoading, authenticated } =
  AppManagerSlice.actions;

export default AppManagerSlice.reducer;
